export const ACTIVE_STATUSES = {
  ACTIVE: 1,
  NOT_ACTIVE: 0,
  REMOVED: -2,
};

export const ANY_TYPE_OMITTED_FIELDS = [
  'options',
  'description',
  'vin',
  'cooling',
  'categories_width',
  'categories_height',
  'brake_rear',
  'brake_front',
  'range_type',
  'contact_name',
  'fueltank_capacity',
  'flowrate',
  'dimension_width',
  'dimension_length',
  'dimension_weight',
  'bucket_count',
  'condition',
  'cabin',
  'brakes',
  'suspension',
  'chassis_suspension',
  'cabin_suspension',
  'date_overhaul',
  'gears',
  'migrated',
  'features',
  'engine_features',
  'color_features',
  'gas_equipment',
  'views_count',
  'caterpillars_width',
  'gearbox_with_dividers',
  'is_bdf',
  'crane_arm',
  'palets',
];

export const OMMITED_FIELDS_BY_TRANSPORT_ID = {
  1: [
    'tacts',
    'engine_order',
    'unloading',
    'tonnage',
    'accessibility',
    'productivity',
    'dimension_height',
    'capacity_body',
    'capacity_bucket',
    'laying_width',
    'lift_height',
    'admission_height',
    'arm_boom',
    'dep_big',
    'axises',
    'fueltanks_count',
    'fueltanks_capacity',
    'couchettes',
  ],
};

export const ENGINES_CONVERTER = {
  dizelniy: 'D',
  elektricheskiy: 'E',
  benzinoviy: 'P',
  gibridniy: 'E',
  gazoviy: 'G',
};

export const GEARBOX_CONVERTER = {
  avtomat: 'A',
  mehanika: 'M',
  variator: 'A',
  robot: 'A',
};

export const WHELL_DRIVE = {
  peredniy: 'FRONT',
  polniy: 'FOUR',
  zadniy: 'REAR',
};

export const FEATURES = {
  'Обогрев руля': 'STEERING_WHEEL_HEATING',
  'Климат-Климат-контроль': 'CLIMATE_CONTROL',
  'Электростеклоподъемники-Передние': 'FRONT_GLASS_LIFT',
  'Мультимедиа-Сенсорный экран': 'MEDIA_SCREEN',
  'Электростеклоподъемники-Все': 'REAR_GLASS_LIFT',
  'AUTONOMOUS_HEATER': 'AUTONOMOUS_HEATER', // -- 
  'Панорамная крыша': 'PANORAMIC_ROOF',
  'Bluetooth': 'BLUETOOTH',
  'Датчик дождя': 'RAIN_DETECTOR',
  '"Обогрев зеркал': 'MIRROR_HEATING',
  'Круиз-контроль': 'CRUISE_CONTROL',
  'Электрорегулировка сидений': 'ELECTRO_SEAT_ADJUSTMENT',
  'HITCH': 'HITCH', // -- 
  'Фары-Ксеноновые': 'XENON_LIGHTS',
  'Противотуманные фары': 'FOG_LIGHTS',
  'Подушки безопасности боковые': 'SIDE_SAFEBAGS',
  'ESP': 'ESP',
  'Рейлинги на крыше': 'RAILINGS',
  'USB': 'USB',
  'Система контроля слепых зон': 'MIRROR_DEAD_ZONE_CONTROL',
  'Система “старт-стоп”': 'DRIVE_AUTO_START',
  'Климат-Кондиционер': 'CONDITIONER',
  'Мультимедиа-CD': 'CD_MP3_PLAYER',
  'Мультимедиа-MP3': 'CD_MP3_PLAYER',
  'STEERING_WHEEL_MEDIA_CONTROL': 'STEERING_WHEEL_MEDIA_CONTROL', // ---
  'Охранные системы': 'ALARM',
  'Подушка безопасности пассажира': 'REAR_SAFEBAGS',
  'Мультимедиа-Навигация': 'NAVIGATOR',
  'Обогрев лобового стекла': 'FRONT_GLASS_HEATING',
  'Охранные системы-Иммобилайзер': 'IMMOBILIZER',
  'Диски-Легкосплавные': 'ALLOY_WHEELS',
  'ABS': 'ABS',
  'Обогрев сидений': 'SEAT_HEATING',
  'Люк': 'HATCH',
  'Камера заднего вида': 'REAR_VIEW_CAMERA',
  'Подушка безопасности водител': 'FRONT_SAFEBAGS',
  'Антипробуксовочная система': 'ANTI_SLIP_SYSTEM', // ---
  'AUX': 'AUX_IPOD',
  'Фары-Светодиодные': 'LED_LIGHTS',
  'Задний парктроник': 'PARKTRONICS',
  'Передний парктроник': 'PARKTRONICS',
};



// WEBPACK FOOTER //
// ./src/shared/constants/adverts.js